/** * * Asynchronously loads the component for
Support Tickets
* */ import { lazyLoad } from "utils/loadable";
export const SupportTickets = lazyLoad(
  () => import("./index"),
  (module) => module.SupportTickets
);
